export default {
  topics: [],
}
